import React, { useEffect, useState, useRef } from 'react';
import CreateQuestions from '../../../component/EliteGame/CreateQuestions';
import QuestionsList from '../../../component/EliteGame/QuestionsList';
import {
  GetFunNLearnList,
  GetMainCategories,
  createQuestion,
  deleteQuestion,
  getQuestionsByQuizType,
  updateQuestion
} from '../../../api/eliteGameApi';
import { ELITE_QUIZ_TYPE } from '../../../utils/constants';
import { useEliteGames } from '../../../context/EliteGamesContext';
import ViewQuestionModal from '../../../component/EliteGame/ViewQuestionModal';
import { errorToast, successToast } from '../../../utils/helper';
import DeletePopup from '../../../component/common/modals/DeletePopup';

const FunLearnManageQuestions = () => {
  const [refresh, setRefresh] = useState(true);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [questions, setQuestions] = useState([]);
  const [funNLearnData, setFunNLearnData] = useState([]);
  const [refreshFlag, setRefreshFlag] = useState(0);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewQuestion, setViewQuestion] = useState(null);
  const [questionId, setQuestionId] = useState(null);
  const [open, setOpen] = useState(false);
  const { setLoading } = useEliteGames();
  const formRef = useRef(null);

  // Function to handle viewing a question
  const handleView = (question) => {
    setViewQuestion(question);
    setViewModalOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const data = await GetFunNLearnList();
        setFunNLearnData(
          data?.data?.map((d) => ({
            ...d,
            name: d.title
          })) || []
        );
      } catch (error) {
        errorToast('Failed to fetch Fun N Learn data', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const getQuestions = async (filter = {}) => {
    setLoading(true);
    try {
      const data = await getQuestionsByQuizType(ELITE_QUIZ_TYPE.FUN_N_LEARN, {
        page,
        limit,
        ...filter
      });
      setQuestions(data || []);
    } catch (error) {
      errorToast('Failed to fetch questions', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getQuestions();
  }, [refresh, page, limit]);

  // Handle filter action for questions
  const handleFilter = (filter) => {
    getQuestions(filter);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const formData = {
        ...data,
        quizType: ELITE_QUIZ_TYPE.FUN_N_LEARN,
        options: [
          data.optionA,
          data.optionB,
          ...(data.questionType != 2 ? [data.optionC, data.optionD] : [])
        ],
        correctAnswer: data[data.answer.value || data.answer]
      };

      // If a question is selected, update it; otherwise, create a new question

      if (selectedQuestion) {
        const response = await updateQuestion(formData, selectedQuestion._id);
        successToast('Question updated successfully', response.message);
        setSelectedQuestion(null);
      } else {
        const response = await createQuestion(formData);
        successToast('Question created successfully', response.message);
      }
      getQuestions();
    } catch (error) {
      errorToast('Error creating/updating question:', error);
    } finally {
      setLoading(false);
      setSelectedQuestion(null);
      setRefreshFlag((prev) => prev + 1); // ✅ trigger reset in all cases
    }
  };

  // Handle delete action for a question
  const handleDelete = async () => {
    setLoading(true);
    try {
      // Call API to delete question
      await deleteQuestion(questionId);
      successToast('Question deleted successfully');
      setRefresh(true); // Refresh questions list after deletion
    } catch (error) {
      errorToast('Error deleting question:', error);
    } finally {
      setLoading(false);
    }
    setRefresh(!refresh);
  };
  /**
   * coming from QuestionsList component send to create question form
   * @param {*} question
   */
  const handleEdit = (question) => {
    setSelectedQuestion(question);
    formRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };

  // Handle refresh action for questions
  const handleRefresh = () => {
    // Reset page to 1 and refresh questions
    setPage(1);
    getQuestions(); // Fetch fresh data
  };
  return (
    <div>
      <div ref={formRef}>
        <CreateQuestions
          onSubmit={onSubmit}
          name={'Fun N Learn'}
          quizType={ELITE_QUIZ_TYPE.FUN_N_LEARN}
          dropDownData={funNLearnData}
          existingQuestion={selectedQuestion}
          resetTrigger={refreshFlag}
        />
      </div>
      <div className="bg-white rounded-lg shadow p-6 m-4">
        <div className="mb-2">
          <span className="text-2xl font-bold text-black-600">Questions for Fun And Learn</span>
        </div>
        <hr className="mb-6" />
        <QuestionsList
          quizType={ELITE_QUIZ_TYPE.FUN_N_LEARN}
          questions={questions}
          dropdowndata={funNLearnData}
          onEdit={handleEdit}
          page={page}
          limit={limit}
          setLimit={setLimit}
          onFilter={handleFilter}
          setPage={setPage}
          onDelete={(id) => {
            setQuestionId(id);
            setOpen(true);
          }}
          onView={handleView}
          onRefresh={handleRefresh}
        />
        {DeletePopup({
          title: 'Confirm Deletion',
          open,
          setOpen,
          message:
            'Are you sure you want to delete this question? All related data will also be deleted.',
          setDelete: handleDelete
        })}
      </div>
      <ViewQuestionModal
        questions={viewQuestion}
        isOpen={viewModalOpen}
        onClose={() => setViewModalOpen(false)}
      />
    </div>
  );
};

export default FunLearnManageQuestions;
